<template>
  <div>
    
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class=""><a @click.stop="goToPage('reporteRoboExtravio')">Aclaraciones y reclamaciones</a></li>
        <li class="active bold">Seguimiento de reporte</li>
      </template>
      <template slot="title">
        Seguimiento a reporte por robo o extravío.
      </template>
      <template slot="body">
        <StealLossReportFollowUp />                
      </template>
    </GenericPage>
  </div>
</template>

<script>
import MPHeader from "@components/main-page/MPHeader";
import StealLossReportFollowUp from "@components/steal-loss-report/StealLossReportFollowUp";
import GenericPage from "./new-portal-views/GenericPage.vue";
export default {
  name: "StealLossReportFollowUpPage",
  components: {
    StealLossReportFollowUp,
    MPHeader,
    GenericPage
  }
}
</script>

<style scoped></style>